"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPillHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var FilterPill_1 = require("../../react/components/FilterPill");
var Contexts_1 = require("../Contexts");
var useFilterPillHeaderStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    filterPillWrapper: {
        paddingBottom: "2px",
    },
    resetFilterLink: {
        color: theme.colors.primary,
        fontSize: "14px",
        fontWeight: 500,
        paddingInlineStart: theme.spacing.base,
        "&:hover": {
            cursor: "pointer",
        },
        display: "inline-block",
        lineHeight: "32px",
    },
}); });
var FilterPillHeader = function (_a) {
    var emitTrackingEvent = _a.emitTrackingEvent, isMobile = _a.isMobile, onClearFiltersClicked = _a.onClearFiltersClicked, pills = _a.pills, translate = _a.translate;
    var classes = useFilterPillHeaderStyles();
    var styleOverride = isMobile ? { paddingLeft: "5px", paddingRight: "5px" } : {};
    var context = (0, react_1.useContext)(Contexts_1.IDataSourceContext);
    var pillKey = (0, react_1.useRef)(
    // get the active pill labels sorted to use as key for determining if filters changed
    pills
        .map(function (pill) { return pill.label; })
        .sort()
        .join("-"));
    // When the filter pills update, reset the data source to obtain the most current data with appropriate filters
    // This is a similar approach to when the user changes and query options change in PerformerDataSourceContext
    (0, react_1.useEffect)(function () {
        var incomingPillKey = pills
            .map(function (pill) { return pill.label; })
            .sort()
            .join("-");
        if (pillKey.current !== incomingPillKey) {
            context.reset();
            pillKey.current = incomingPillKey;
        }
    }, [pills]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes.filterPillWrapper, style: styleOverride, children: [pills.map(function (pill, index) {
                return ((0, jsx_runtime_1.jsx)(FilterPill_1.FilterPill, { emitTrackingEvent: emitTrackingEvent, onFilterClose: pill.onFilterClose, label: pill.label, translate: translate }, pill.label + index));
            }), !isMobile && pills.length > 0 ? ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: classes.resetFilterLink, "data-ta-locator": "FilterPillHeader-clearFilters", onClick: onClearFiltersClicked, children: translate("search.filters.clear_filters") }) })) : null] }));
};
exports.FilterPillHeader = FilterPillHeader;
exports.FilterPillHeader.displayName = "FilterPillHeader";
//# sourceMappingURL=FilterPillHeader.js.map